// @ts-nocheck
import React, { useState, useRef, useEffect } from 'react';

/**
 * ExpiryDatePicker — pill showing the current expiry ("Never" or a
 * date). Clicking it opens a small dropdown with a native date input
 * plus a "Never expires" checkbox — no modal, just a popover.
 */
const formatDisplay = (isoDate) => {
    if (!isoDate) return '';
    const [y, m, d] = isoDate.split('-');
    return `${d}/${m}/${y.slice(2)}`;
};

const toIso = (ddmmyy) => {
    // best-effort convert "11/11/26" -> "2026-11-11" for the <input type="date">
    if (!ddmmyy || ddmmyy === 'Never') return '';
    const [d, m, y] = ddmmyy.split('/');
    const year = y?.length === 2 ? `20${y}` : y;
    return `${year}-${m}-${d}`;
};

const ExpiryDatePicker = ({ value, onChange }) => {
    const [open, setOpen] = useState(false);
    const [neverExpires, setNeverExpires] = useState(value === 'Never');
    const [isoDate, setIsoDate] = useState(toIso(value));
    const ref = useRef(null);

    useEffect(() => {
        if (!open) return;
        const handler = (e) => {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, [open]);

    const apply = () => {
        onChange?.(neverExpires ? 'Never' : (isoDate ? formatDisplay(isoDate) : 'Never'));
        setOpen(false);
    };

    return (
        <div className="edp-wrap" ref={ref}>
            <button type="button" className="edp-pill" onClick={() => setOpen(p => !p)}>
                {value || 'Never'}
                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                    <polyline points="6 9 12 15 18 9" />
                </svg>
            </button>

            {open && (
                <div className="edp-dropdown">
                    <input
                        type="date"
                        value={isoDate}
                        disabled={neverExpires}
                        onChange={e => setIsoDate(e.target.value)}
                        className="edp-dropdown__input"
                    />
                    <label className="edp-dropdown__checkbox">
                        <input
                            type="checkbox"
                            checked={neverExpires}
                            onChange={e => setNeverExpires(e.target.checked)}
                        />
                        Never expires
                    </label>
                    <button className="edp-dropdown__apply" onClick={apply}>Apply</button>
                </div>
            )}
        </div>
    );
};

export default ExpiryDatePicker;